import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const ProofSection = () => {
    return (
        <Box
            component="section"
            aria-labelledby="pricing-proof-heading"
            sx={{
                pt: { xs: 5, md: 6.5, lg: 7 },
                pb: { xs: 4, md: 4.5, lg: 4.5 },
                background: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 45%, #F8FAFF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.08)',
            }}
        >
            <Container maxWidth="xl">
                <Box sx={{ width: '100%',textAlign: 'center' } }>
                    <Typography
                        id="pricing-proof-heading"
                        component="h2"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        Proof
                    </Typography>

                    <Typography
                        component="p"
                        sx={{
                            fontSize: { xs: '1.125rem', sm: '1.25rem', md: '1.35rem' },
                            fontWeight: 600,
                            lineHeight: 1.65,
                            color: 'rgba(15, 23, 42, 0.92)',
                            textAlign: 'center',
                            m: 0,
                            mb: 2.5,
                        }}
                    >
                        Five rehabilitation centers fully operational on the platform. 1000+ sessions
                        tracked every month. 35 active therapists. Growing 40% month on month.
                    </Typography>

                    <Typography
                        component="p"
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.0625rem' },
                            lineHeight: 1.72,
                            color: 'rgba(15, 23, 42, 0.75)',
                            m: 0,
                            textAlign: 'center',
                        }}
                    >
                        Used by rehab centres running active field operations. Not pilot teams, not
                        clinic-only setups.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default ProofSection;
